import { t } from '../i18n.es.js';
import React from 'react';
import { styled, Card, LazyImage, Button } from '@teko/ui';
import { CustomLink } from '../Common/CustomLink/CustomLink.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const CardContent = styled.div`
  padding: 0.5rem;
`;
const Name = styled.div`
  font-size: 1.125rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
  height: 54px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const Flex = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const StyledCard = styled(Card)(({ outDate }) => `
  box-shadow: 0.1rem 0.1rem 0.5rem 0.1rem rgba(0, 0, 0, 0.1);
  ${outDate && `
  filter: grayscale(100%);
  opacity: 0.6;
  `}
`);
const FromDateToDate = styled.div``;
const CampaignItem = (_a) => {
  var _b = _a, {
    imageUrl,
    name,
    targetPath,
    dateFrom,
    dateTo
  } = _b, props = __objRest(_b, [
    "imageUrl",
    "name",
    "targetPath",
    "dateFrom",
    "dateTo"
  ]);
  const formattedDateTo = dateTo ? dateTo.replace(/-/g, "/") : "2099/12/31T12:00:00Z";
  const outDate = new Date(formattedDateTo).getTime() - new Date().getTime() < 0;
  const dateFromStr = dateFrom ? new Date(dateFrom).toLocaleDateString() : "";
  const dateToStr = dateTo ? new Date(dateTo).toLocaleDateString() : "";
  return /* @__PURE__ */ React.createElement(StyledCard, __spreadProps(__spreadValues({}, props), {
    outDate
  }), /* @__PURE__ */ React.createElement(CustomLink, {
    targetPath,
    targetType: "_blank"
  }, /* @__PURE__ */ React.createElement(LazyImage, {
    aspectRatio: 1.93,
    src: imageUrl
  })), /* @__PURE__ */ React.createElement(CardContent, null, /* @__PURE__ */ React.createElement(CustomLink, {
    targetPath,
    targetType: "_blank"
  }, /* @__PURE__ */ React.createElement(Name, null, name)), /* @__PURE__ */ React.createElement(Flex, null, /* @__PURE__ */ React.createElement("div", null, !outDate && /* @__PURE__ */ React.createElement(FromDateToDate, null, dateFromStr, dateToStr ? ` - ${dateToStr}` : "")), /* @__PURE__ */ React.createElement(Button, {
    disabled: outDate,
    tag: "a",
    href: targetPath,
    variant: "primary"
  }, outDate ? t("\u0110\xE3 k\u1EBFt th\xFAc") : t("Xem chi ti\u1EBFt")))));
};

export { CampaignItem };
